import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/student-feedback/")({
  head: () => ({
    meta: [{ title: "学员反馈 · imiker CRM" }],
  })
});
